export function isEmail(str: null | string | undefined) {
  return str?.includes("@");
}

export function isPhone(str: null | string | undefined) {
  return !!str && /^\+\d+$/.test(str);
}

export const UNKNOWN_VALUE = "UNKNOWN";

export function formatToDollars(amount: number, specialCaseFree = false, forceCents = false): string {
  // Check if the number has a fractional part.
  if (amount === 0 && specialCaseFree) {
    return "Free";
  }
  const hasCents = amount % 1 !== 0;

  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    // Dynamically set fraction digits based on the check
    minimumFractionDigits: hasCents || forceCents ? 2 : 0,
    maximumFractionDigits: hasCents || forceCents ? 2 : 0,
  });

  return formatter.format(amount);
}

export function prettyPassID(passID: string) {
  if (passID.length < 8) return passID.toUpperCase();
  return passID.slice(-8).toUpperCase();
}
